<template>
  <el-dialog
    :title="title"
    :visible.sync="formVisible"
    width="30%"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <el-form
      :model="ruleForm"
      status-icon
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      :rules="rules"
      label-position="left"
    >
      <el-form-item label prop="username">
        <span slot="label">
          账号
          <span style="color: red">*</span>
        </span>
        <el-input
          type="text"
          v-model="ruleForm.username"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <span slot="label">
          密码
          <span style="color: red">*</span>
        </span>
        <el-input
          type="password"
          v-model="ruleForm.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="repeatPassword">
        <span slot="label">
          确认密码
          <span style="color: red">*</span>
        </span>
        <el-input type="password" v-model="ruleForm.repeatPassword"></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="name">
        <el-input v-model.number="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="dept">
        <!-- <el-input v-model.number="ruleForm.osType"></el-input> -->
        <!-- <el-select v-model="ruleForm.dept" placeholder="请选择对应的部门"> -->
        <el-cascader
          v-model="ruleForm.dept"
          :options="deptOptions"
        ></el-cascader>
      </el-form-item>

      <el-form-item label="备注" prop="desc">
        <el-input v-model="ruleForm.desc"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="saveForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: this.ruleFormProps,
      rules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            pattern: /^[0-9a-zA-Z_]{1,}$/,
            message: "账号只能由字母，数字或下划线组成",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repeatPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      deptOptions: [
        {
          label: "研发部",
          value: "2",
          children: [
            {
              label: "研发一部",
              value: "3",
            },
            {
              label: "研发二部",
              value: "4",
            },
            {
              label: "研发三部",
              value: "5",
            },
          ],
        },
        {
          label: "测试部",
          value: "6",
        },
        {
          label: "市场部",
          value: "7",
          children: [
            {
              label: "市场部",
              value: "7",
            },
            {
              label: "投放组",
              value: "13",
            },
          ],
        },
        {
          label: "美术部",
          value: "8",
        },
        {
          label: "财务部",
          value: "9",
        },
        {
          label: "总经办",
          value: "10",
        },
        {
          label: "策划部",
          value: "11",
        },
        {
          label: "人事行政部",
          value: "12",
        },
      ],
    };
  },
  props: {
    formVisible: Boolean,
    ruleFormProps: Object,
    addormodify: String,
    userId: String,
    title: String,
  },
  methods: {
    cancelForm() {
      this.$emit("closeDialogForm");
    },
    saveForm(formName) {
      this.$emit("showLoading");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = { ...this.ruleForm };
          this.userId == "" ? null : (param["userId"] = this.userId);
          param.dept =
            typeof param.dept == "string"
              ? param.dept
              : param.dept
              ? param.dept.join()
              : undefined;
          delete param["repeatPassword"];
          this.$store.dispatch(this.userId == "" ? "addNewUser" : "editUser", {
            param,
            cb: (data) => {
              if (data.code !== "0000") {
                this.$notify({
                  title: "error",
                  message: this.userId == "" ? "创建用户失败" : "修改用户失败",
                  type: "error",
                });
              } else {
                this.$notify({
                  title: "success",
                  message: this.userId == "" ? "创建用户成功" : "修改用户成功",
                  type: "success",
                });
                this.$emit("closeDialogForm");
                this.$emit("reloadTable");
              }
            },
          });
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    ruleFormProps: function (val) {
      this.ruleForm = val;
    },
  },
};
</script>